/**
 * drive侧相关的运行时环境判断
 * 统一在这里派发
 * 从属关系图以及文档示例在此文档查看：https://docs.qq.com/flowchart/DUXB2dG9wdkVjR2hD
 * 对云文档关系不清楚的请先查看上面文档！！
 * 简单说下：
 * 云文档包含 云编、非云编、weboffice，其中非云编为历史遗留文档（不可编辑）
 * 这三类文档优先用各自的cac配置控制菜单，云编又分为了所有者和查看者，可以用下面的运行时函数（isPreviewDriveFile、isEditableDriveFile）区分
 * 云文档提供了一个高纬度条件判断，即所有的文档预览模式（云编查看者、非云编、weboffice），均会内嵌iframe，链接带有inToastPreview，可用下面的运行时函数（isPreview）区分
 */
import { getQuery } from 'sutils';
import { getAppConfigInstance } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

/**
 * 云文档（云编、非云编、weboffice）
 */
export const isCloudSlide = () => isClientDriveFile() || isClientPreview() || isPreview();

/**
 * 预览服务（云编查看者、非云编、weboffice）
 * 所有内嵌iframe的云文档均为预览服务，不可编辑
 */
export const isPreview = () => !!getQuery('inToastPreview');

/**
 * 云编文档（所有者、查看者）
 * 兼容 继承云文档基础配置的其他渠道云文档
 */
export const isClientDriveFile = () => getQuery('client')?.includes('drive_file')
    || getAppConfigInstance().getConfig<string>('client')
        ?.includes?.('drive_file')
    || !!getDriveFileExt();

/**
 * 获取云编文档后缀
 */
export const getDriveFileExt = () => (window.basicClientVars?.docInfo as any)?.cosInfo?.driveExt;

/**
 * 云编文档（查看者）
 */
export const isPreviewDriveFile = () => isClientDriveFile() && isPreview();

/**
 * 云编文档（所有者）
 */
export const isEditableDriveFile = () => isClientDriveFile() && !isPreviewDriveFile();

/**
 * 非云编文档（非云编文档所有者和查看者完全一致，均不可编辑）
 * 历史遗留数据，后续不再新增
 */
export const isClientPreview = () => getQuery('client') === 'preview';

/**
 *云文档环境入口
 */
export const DRIVE_ENV = {
    /**
     * 云文档（云编、非云编、weboffice）
     */
    IS_CLOUD_SLIDE: isCloudSlide(),
    /**
     * 预览服务（云编查看者、非云编、weboffice）
     * 所有内嵌iframe的云文档均为预览服务，不可编辑
     */
    IS_PREVIEW: isPreview(),
    /**
     * 云编文档（所有者、查看者）
     */
    IS_CLIENT_DRIVE_FILE: isClientDriveFile(),
    /**
     * 云编文档（查看者）
     */
    IS_PREVIEW_DRIVE_FILE: isPreviewDriveFile(),
    /**
     * 云编文档（所有者）
     */
    IS_EDITABLE_DRIVE_FILE: isEditableDriveFile(),
    /**
     * 非云编文档（非云编文档所有者和查看者完全一致，均不可编辑）
     * 历史遗留数据，后续不再新增
     */
    IS_CLIENT_PREVIEW: isClientPreview(),
};
